import { appendQueryString } from "./appendQueryString";

type Params = Record<string, any>;

interface CommunityMemberParams {
  params?: Params;
  public_uid: string;
}

export const communityMemberProfilePath = ({
  public_uid,
  params = {},
}: CommunityMemberParams) => appendQueryString(`/u/${public_uid}`, params);
